import {FC} from 'react'
import s from './index.module.scss'

type Props = {
  renderForm: () => any
}

const Register: FC<Props> = ({renderForm}) => {
  return (
    <div id='form' className={s.root}>
      <div className={s.form}>
        {renderForm()}
      </div>
    </div>
  )
}

export default Register
